
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Track scroll position to toggle navbar background/shadow
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    // Clean‑up listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Smooth scroll to a section and close the mobile menu
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className={`flex items-center justify-between transition-all duration-300 ${
          isScrolled ? 'py-2' : 'py-4'
        }`}>
          {/* Logo on the left - switches based on scroll state */}
          <div className="flex items-center">
            {isScrolled ? (
              <img
                src="https://static.readdy.ai/image/d808c48a5b990d9ac02bd9f33c7a3dc7/6f3ba6572b662e7c0072123fc29f8450.png"
                alt="MGroup Agency"
                className="h-12 md:h-14 lg:h-16 w-auto -ml-0 md:-ml-8 transition-all duration-300"
              />
            ) : (
              <img
                src="https://static.readdy.ai/image/d808c48a5b990d9ac02bd9f33c7a3dc7/c12788db0a475cdcb4cdb431feb79929.png"
                alt="MGroup Agency"
                className="h-20 md:h-32 lg:h-36 w-auto -ml-0 md:-ml-8"
              />
            )}
          </div>

          {/* Desktop Menu on the right */}
          <div className="hidden md:flex items-center space-x-4 lg:space-x-6">
            {[
              { id: 'home', label: 'Home' },
              { id: 'about', label: 'About' },
              { id: 'services', label: 'Services' },
              { id: 'process', label: 'Process' },
              { id: 'portfolio', label: 'Portfolio' },
              // { id: 'case-studies', label: 'Case Studies' },
              { id: 'contact', label: 'Contact' },
            ].map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`text-sm lg:text-base font-medium transition-colors duration-300 hover:text-teal-500 whitespace-nowrap cursor-pointer ${
                    isScrolled ? 'text-gray-700' : 'text-white'
                  }`}
                >
                  {item.label}
                </button>
              )
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i
              className={`${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              } text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}
            ></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg rounded-b-2xl overflow-hidden">
            <div className="flex flex-col py-4">
              {[
                { id: 'home', label: 'Home' },
                { id: 'about', label: 'About' },
                { id: 'services', label: 'Services' },
                { id: 'process', label: 'Process' },
                { id: 'portfolio', label: 'Portfolio' },
                // { id: 'case-studies', label: 'Case Studies' },
                { id: 'contact', label: 'Contact' },
              ].map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className="text-left px-6 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-teal-500 transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                )
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
